export enum CartType {
    INBANK_RENTAL_CART = 'inbank_rental_cart',
    SLICE3_CART = 'slice3_cart',
    REGULAR_CART = 'regular_cart',
    ESTO_SLICE3_CART = 'esto_slice3_cart',
}
